import React from 'react';
import PropTypes from 'prop-types';

const Minus = ({ className }) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M6 10.985h12v2.016h-12v-2.016z"></path>
    </svg>
  );
};

Minus.propTypes = {
  className: PropTypes.string,
};
export default Minus;
